import React from 'react';
import Layout from '../../Components/Common/Layout';
import Purchases from '../../Components/Purchases';

const PurchasesPage = () => {
  return (
    <Layout title={'purchases'}>
      <Purchases />
    </Layout>
  );
};

export default PurchasesPage;
